export const isRegex = /^[a-zA-Z0-9]{6,12}$/; // 아이디 정규식
export const passRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/; // 비밀번호 정규식
export const phoneRegex = /^010-?([0-9]{4})-?([0-9]{4})$/;
export const nameRegex = /^[가-힣a-zA-Z]+$/;
export const nicknameRegex = /^[가-힣a-zA-Z0-9]{2,8}$/;
